import {
  ProductItemModel,
  transformItemBoxDto,
  transformPartialUserDtoToProductItemUser,
  findThumbnail,
} from '@marketplace-web/item-box/product-item-data'

import { ItemSearchParamsDto } from '../types/item-search'
import {
  ItemPageItemsBlockDto,
  ItemPageItemsBlockHeaderDto,
  ItemPageItemsBlockHeaderPluginModel,
  ItemPageItemsBlockPluginModel,
  ItemsBlockItemDto,
} from '../types/items-block'
import { transformCurrencyAmountDto } from './currency'

enum ItemThumbnailSize {
  Medium = 'thumb150x210',
  Large = 'thumb310x430',
}

const getItemThumbnail = (
  photos: Array<{
    is_main: boolean
    thumbnails: Array<{ type: ItemThumbnailSize | string; url: string }>
  }>,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ is_main }) => is_main)

  return findThumbnail(photo, size)
}

const getDominantColor = (photos: Array<{ is_main: boolean; dominant_color_opaque: string }>) => {
  if (!photos.length) return null

  const photo = photos.find(({ is_main }) => is_main === true)

  if (!photo) return null

  return photo.dominant_color_opaque
}

export const transformItemsBlockItemDtoToProductItem = (
  item: ItemsBlockItemDto,
): ProductItemModel & {
  searchTrackingParams?: ItemSearchParamsDto | null
} => ({
  id: item.id,
  title: item.title,
  url: item.url,
  photos: item.photo
    ? [
        {
          url: item.photo.url,
          thumbnails: item.photo.thumbnails,
          isMain: item.photo.is_main,
          imageNo: item.photo.image_no,
        },
      ]
    : [],
  viewCount: item.view_count,
  favouriteCount: item.favourite_count,
  user: transformPartialUserDtoToProductItemUser(item.user),
  price: transformCurrencyAmountDto(item.price),
  thumbnailUrl: item.photo ? getItemThumbnail([item.photo], ItemThumbnailSize.Large) : null,
  dominantColor: item.photo ? getDominantColor([item.photo]) : null,
  badge: item.badge,
  isPromoted: item.promoted,
  isDraft: item.is_draft,
  isFavourite: item.is_favourite,
  searchTrackingParams: item.search_tracking_params,
  priceWithDiscount: item.discount_price ? transformCurrencyAmountDto(item.discount_price) : null,
  serviceFee: item.service_fee ? transformCurrencyAmountDto(item.service_fee) : null,
  totalItemPrice: item.total_item_price
    ? transformCurrencyAmountDto(item.total_item_price)
    : undefined,
  itemBox: item.item_box && transformItemBoxDto(item.item_box),
})

export const getItemPageItemsBlockPluginModel = (
  pluginData: ItemPageItemsBlockDto,
  horizontalScrollEnabled: boolean,
): ItemPageItemsBlockPluginModel => ({
  itemId: pluginData.item_id,
  contentSource: pluginData.content_source,
  items: pluginData.items ? pluginData.items.map(transformItemsBlockItemDtoToProductItem) : null,
  horizontalScrollEnabled,
})

export const getItemPageItemsBlockHeaderPluginModel = (
  pluginData: ItemPageItemsBlockHeaderDto,
): ItemPageItemsBlockHeaderPluginModel => {
  const {
    header_cta: headerCta,
    item_id: itemId,
    title,
    content_source: contentSource,
  } = pluginData

  return {
    itemId,
    title,
    contentSource,
    headerCta: headerCta ? { title: headerCta.title, url: headerCta.url } : null,
  }
}
